var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 1C4.44772 1 4 1.44772 4 2V21C4 21.5523 4.44772 22 5 22H8.5H20C20.5523 22 21 21.5523 21 21V2C21 1.44772 20.5523 1 20 1H8.5H5ZM8.5 1C8.22386 1 8 1.22386 8 1.5V21.5C8 21.7761 8.22386 22 8.5 22C8.77614 22 9 21.7761 9 21.5V1.5C9 1.22386 8.77614 1 8.5 1ZM12.5 5C12.5 4.72386 12.7239 4.5 13 4.5H17C17.2761 4.5 17.5 4.72386 17.5 5C17.5 5.27614 17.2761 5.5 17 5.5H13C12.7239 5.5 12.5 5.27614 12.5 5ZM13 8.5C12.7239 8.5 12.5 8.72386 12.5 9C12.5 9.27614 12.7239 9.5 13 9.5H17C17.2761 9.5 17.5 9.27614 17.5 9C17.5 8.72386 17.2761 8.5 17 8.5H13Z",
    fill: "#B0B0B0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.0c0f9ebf5d82417c15b09b4a3241e697.svg";
export { ForwardRef as ReactComponent };